module.exports = __webpack_public_path__ + "static/media/ajax-Loader.8c8f11e5.gif";